/* eslint-disable react/prop-types */
import React from 'react';
import { AButton } from 'components/Antd';
import T from 'i18n-react';
import classes from './FilterDropdown.module.scss';

const FilterDropdownFooter = ({ hasValue, onReset, onApply }) => {
  const resetProps = React.useMemo(() => {
    const defaultProps = {};
    if (hasValue) {
      defaultProps.type = 'primary';
      defaultProps.ghost = true;
    }
    return defaultProps;
  }, [hasValue]);
  return (
    <div className={classes.filterDropdownFooter}>
      <AButton type="primary" onClick={onApply}>
        {T.translate('general.apply')}
      </AButton>
      <AButton onClick={onReset} type="default" {...resetProps}>
        {T.translate('general.reset')}
      </AButton>
    </div>
  );
};

export default FilterDropdownFooter;
